import { useQuery } from '@tanstack/react-query';
import { ProductBehavior, ProductsApi } from '@up2stay/up2promo-api-client';

import { useAuthStore } from '@/core/store/auth.store';
import { useCurrentWorkspace } from '@/core/store/workspace.store';

const PHYSICAL_CARDS_PAGE_SIZE = 50;

export function usePhysicalBusinessCards(options?: { enabled?: boolean }) {
  const currentWorkspace = useCurrentWorkspace();
  const user = useAuthStore((state) => state.user);
  const userId = user?.id;

  const query = useQuery({
    queryKey: [
      'physical-business-cards',
      currentWorkspace?.id,
      userId,
    ] as const,
    queryFn: async () => {
      if (!currentWorkspace?.id || !userId) {
        return [];
      }
      const res = await ProductsApi.findAll({
        path: { workspaceId: currentWorkspace.id },
        query: {
          page: 1,
          limit: PHYSICAL_CARDS_PAGE_SIZE,
          userId,
          // Same set as the pre-v2 `productTypes: [BC]` filter: the
          // effective behaviour is PROFILE (factory item, else target).
          behaviors: [ProductBehavior.PROFILE],
        },
      });
      return res.data?.data ?? [];
    },
    enabled: Boolean(
      currentWorkspace?.id && userId && options?.enabled !== false,
    ),
  });

  return {
    cards: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
